export default __webpack_public_path__ + "static/media/pool-res6.a0ba05fc.jpg";